import { defaultTheme as theme } from "@deliverr/ui/lib-esm/shared/theme";
import styled from "@emotion/styled";
import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { StyledCell, StyledLabel } from "../emotion/forms";

export type TableComponentProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  name: string;
  error?: string;
  label?: string;
  errors?: any;
};

const StyledErrorMessage = styled.span`
  color: ${theme.colors.RED[500]};
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F2};
`;

const StyledPassMessage = styled.span`
  color: ${theme.colors.GREEN[500]};
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F2};
`;

export const TableComponent = React.forwardRef<
  HTMLInputElement,
  TableComponentProps
>(
  (
    {
      errors,
      className,
      error,
      label,
      name,
      onKeyPress,
      children,
      ...inputProps
    }: TableComponentProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const active = errors && Boolean(errors[name || ""]);

    //
    // the hard coded widths is a kludge to ensure table does not bounce around, need to
    //  fix that property
    return (
      <tbody>
        <tr>
          <StyledCell>
            {label && <StyledLabel htmlFor={name}>{label}</StyledLabel>}
          </StyledCell>
          <StyledCell width={"300px"}>{children}</StyledCell>
          <StyledCell width={"400px"}>
            {active ? (
              <StyledErrorMessage>
                {errors[name || ""].message}
              </StyledErrorMessage>
            ) : (
              <StyledPassMessage>&#10003;</StyledPassMessage>
            )}
          </StyledCell>
        </tr>
      </tbody>
    );
  }
);
